import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchServiceBrandList } from '@/services/receipt/examine';

/**
 * 获取租赁品牌数据（小票审核列表查询的品牌数据）
 */
const useServiceBrandList = () => {
  const { serviceBrandList, setServiceBrandList } = useReadyInfo();

  const {
    run: getServiceBrandList,
    data,
    loading,
  } = useRequest(fetchServiceBrandList, { manual: true });

  useEffect(() => {
    if (!serviceBrandList || !serviceBrandList?.length) {
      getServiceBrandList().then((res) =>
        setServiceBrandList(
          res?.map((brand) => {
            return {
              label: brand.brand_name,
              value: brand.id,
            };
          }) ?? []
        )
      );
    }
  }, [serviceBrandList]);

  return {
    data:
      serviceBrandList ||
      (data?.map((brand) => {
        return {
          label: brand.brand_name,
          value: brand.id,
        };
      }) ??
        []),
    loading,
  };
};

export default useServiceBrandList;
